import React, { useEffect, useState } from "react";
import PatientService from "../../../../../../Services/PatientService";
import UserService from "../../../../../../Services/UserService";
import AccountService from "../../../../../../Services/AccountService";
import ClinicService from "../../../../../../Services/ClinicService";
import PrescriptionHeader from "./PrescriptionHeader";
import PrescriptionFooter from "./PrescriptionFooter";

const PrescriptionDetails = ({ prescription, selectedPatient }) => {
  const [doctorData, setDoctorData] = useState();
  const [hospitalAccountData, setHospitalAccountData] = useState(null);
  const [selectedPatientDetails, setSelectedPatientDetails] = useState([]);
  const [clinicDetails, setClinicDetails] = useState(null);
  const [age, setAge] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAllData = async () => {
      setIsLoading(true);
      await fetchDoctorData();
      await fetchHospitalData(prescription?.account_Id);
      await fetchClinicData(prescription?.clinic_Id);
      await fetchPatientDetails(selectedPatient?.patientId);
      setIsLoading(false);
    };
    fetchAllData();
  }, []);

  const fetchPatientDetails = async (Id) => {
    const payload = {
      patientId: Id,
    };
    try {
      const response = await PatientService.PatientListFilter(payload);
      setSelectedPatientDetails(response.data[0]);
      const dobData = response.data[0].dob;
      const dobYear = dobData?.split("/")[2];
      const currYear = new Date().getFullYear();
      if (dobYear) {
        const patientAge = currYear - Number(dobYear);
        setAge(patientAge);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchDoctorData = async () => {
    try {
      const response = await getDoctorName(prescription.userId);
      setDoctorData(response?.data[0]);
    } catch (e) {
      console.error(e);
    }
  };

  const getDoctorName = async (id) => {
    const payload = {
      userId: id,
    };
    try {
      const response = await UserService.getUser(payload);
      return response;
    } catch (e) {
      console.error(e);
    }
  };

  const fetchHospitalData = async (id) => {
    const payload = {
      account_Id: id,
    };
    const response = await AccountService.AccountList(payload);
    setHospitalAccountData(response.data[0]);
  };

  const fetchClinicData = async (clinic_Id) => {
    const payload = {
      clinic_Id,
    };
    const response = await ClinicService.getClinicList(payload);
    setClinicDetails(response.data[0]);
  };

  return (
    <section>
      <div
        id="prescription"
        className="w-full mb-4 border rounded overflow-x-auto cursor-pointer"
      >
        {isLoading ? (
          <div className="w-full flex h-screen justify-center items-center">
            <div className="spinner"></div>
          </div>
        ) : (
          <>
            <div className="p-3">
              <div className="flex justify-between"></div>
              <PrescriptionHeader
                clinicDetails={clinicDetails}
                doctorData={doctorData}
                hospitalAccountData={hospitalAccountData}
              />

              <hr className="hr-line mt-2 border-t-2 border-gray-400" />
              <div className="mt-3">
                <div className="flex justify-end gap-1">
                  <div className="text-sm font-bold">Date:</div>
                  <h6 className="text-sm text-gray-700 font-semibold">
                    {prescription?.consultationDate
                      ? `${prescription?.consultationDate
                          .slice(0, 11)
                          .split("-")[2]
                          .trim()}-${
                          prescription?.consultationDate
                            .slice(0, 11)
                            .split("-")[1]
                        }-${
                          prescription?.consultationDate
                            .slice(0, 11)
                            .split("-")[0]
                        }`
                      : ""}
                  </h6>
                </div>
              </div>
              <div className="flex gap-5  my-2">
                <div className="text-sm font-bold flex gap-1">
                  Name:
                  <span className="text-sm text-gray-500 font-semibold">
                    {selectedPatient?.patientName
                      ? selectedPatient?.patientName
                      : selectedPatient?.firstName +
                        " " +
                        selectedPatient?.lastName}
                  </span>
                </div>
                <div className="text-sm font-bold flex gap-1">
                  Age/Gender:
                  <span className="text-sm text-gray-500 font-semibold">
                    {age ? age : "NA"}/
                    {selectedPatientDetails?.gender
                      ? selectedPatientDetails?.gender
                      : "NA"}
                  </span>
                </div>
                <div className="text-sm font-bold flex gap-1">
                  Phone Number:
                  <span className="text-sm text-gray-500 font-semibold">
                    {selectedPatientDetails?.mobile}
                  </span>
                </div>

                <div className="text-sm font-bold flex gap-1">
                  Visit Type:
                  <span className=" text-sm text-gray-500 font-semibold">
                    {prescription.consultationType}
                  </span>
                </div>
              </div>
              <hr />
              <div className="flex gap-3 my-3 flex-wrap justify-stretch">
                <div
                  className={`gap-1 w-[20%] ${
                    prescription?.patientVitals?.find(
                      (vital) => vital.vitalCode === "BPS"
                    )?.value
                      ? "flex"
                      : "hidden"
                  }`}
                >
                  <label className="font-medium text-sm">BP:</label>
                  <span className="text-gray-500 text-sm">
                    {`${
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "BPS"
                      )?.value
                    }/${
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "BPD"
                      )?.value
                    }`}{" "}
                    mmHg
                  </span>
                </div>
                <div
                  className={`gap-1 w-[20%] ${
                    prescription?.patientVitals.find(
                      (vital) => vital.vitalCode === "BPD"
                    )?.value
                      ? "flex"
                      : "hidden"
                  }`}
                >
                  <label className="font-medium text-sm">Pulse Ox:</label>
                  <span className="text-gray-500 text-sm">
                    {
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "PO"
                      )?.value
                    }{" "}
                    %
                  </span>
                </div>
                <div
                  className={`gap-1 w-[20%] ${
                    prescription?.patientVitals.find(
                      (vital) => vital.vitalCode === "HR"
                    )?.value
                      ? "flex"
                      : "hidden"
                  }`}
                >
                  <label className="font-medium text-sm">Heart Rate:</label>
                  <span className="text-gray-500 text-sm">
                    {
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "HR"
                      )?.value
                    }{" "}
                    Beats/min
                  </span>
                </div>
                <div
                  className={`gap-1 w-[30%] ${
                    prescription?.patientVitals.find(
                      (vital) => vital.vitalCode === "RR"
                    )?.value
                      ? "flex"
                      : "hidden"
                  }`}
                >
                  <label className="font-medium text-sm">
                    Respiration Rate:
                  </label>
                  <span className="text-gray-500 text-sm">
                    {
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "RR"
                      )?.value
                    }{" "}
                    Breaths/min
                  </span>
                </div>
                <div
                  className={`gap-1 w-[20%] ${
                    prescription?.patientVitals.find(
                      (vital) => vital.vitalCode === "TP"
                    )?.value
                      ? "flex"
                      : "hidden"
                  }`}
                >
                  <label className="font-medium text-sm">Temperature:</label>
                  <span className="text-gray-500 text-sm">
                    {
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "TP"
                      )?.value
                    }{" "}
                    °F
                  </span>
                </div>
                <div
                  className={`gap-1 w-[20%] ${
                    prescription?.patientVitals.find(
                      (vital) => vital.vitalCode === "HI"
                    )?.value
                      ? "flex"
                      : "hidden"
                  }`}
                >
                  <label className="font-medium text-sm">Height:</label>
                  <span className="text-gray-500 text-sm">
                    {
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "HI"
                      )?.value
                    }{" "}
                    cm
                  </span>
                </div>
                <div
                  className={`gap-1 w-[20%] ${
                    prescription?.patientVitals.find(
                      (vital) => vital.vitalCode === "WE"
                    )?.value
                      ? "flex"
                      : "hidden"
                  }`}
                >
                  <label className="font-medium text-sm">Weight:</label>
                  <span className="text-gray-500 text-sm">
                    {
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "WE"
                      )?.value
                    }{" "}
                    kg
                  </span>
                </div>
                <div
                  className={`gap-1 w-[20%] ${
                    prescription?.patientVitals.find(
                      (vital) => vital.vitalCode === "BMI"
                    )?.value
                      ? "flex"
                      : "hidden"
                  }`}
                >
                  <label className="font-medium text-sm">BMI:</label>
                  <span className="text-gray-500 text-sm">
                    {
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "BMI"
                      )?.value
                    }{" "}
                    Kg/m<sup>2</sup>
                  </span>
                </div>
              </div>

              <hr className="hr-line mt-3" />

              <div className="grid grid-cols-1 my-2">
                <p>
                  <b className=" font-bold">Chief Complaint : </b>
                  <span className="text-gray-500 font-semibold">{`${prescription?.consultationReason
                    ?.charAt(0)
                    .toUpperCase()}${prescription?.consultationReason?.slice(
                    1
                  )}`}</span>
                </p>
              </div>
              <div className="mb-5">
                <p className="">
                  <span className="font-bold">Symptoms : </span>
                  <span className="text-gray-500 font-semibold">
                    {prescription?.symptoms}
                  </span>
                </p>
              </div>
              {prescription?.patientDiagnosisDetails?.filter(
                (diagnosis) =>
                  diagnosis.diagnosisType === "Primary" &&
                  diagnosis?.status === 1
              )?.length !== 0 && (
                <div className="grid grid-cols-1 my-2">
                  <p className="">
                    <b className="font-bold">Primary Diagnosis :</b>
                  </p>

                  <>
                    <ol className="list-decimal ml-5">
                      {prescription?.patientDiagnosisDetails
                        ?.filter(
                          (diagnosis) =>
                            diagnosis?.diagnosisType === "Primary" &&
                            diagnosis?.status === 1
                        )
                        ?.map((primaryDiagnosis) => (
                          <li>
                            <span>
                              {primaryDiagnosis?.diagnosisDescription}
                            </span>
                            <span className="font-bold">
                              ({primaryDiagnosis?.diagnosisCode})
                            </span>
                          </li>
                        ))}
                    </ol>
                  </>
                </div>
              )}

              {prescription?.patientDiagnosisDetails?.filter(
                (diagnosis) =>
                  diagnosis?.diagnosisType === "Secondary" &&
                  diagnosis?.status === 1
              )?.length !== 0 && (
                <div className="grid grid-cols-1 my-2">
                  <p className="">
                    <b className="font-bold">Secondary Diagnosis :</b>
                  </p>

                  <>
                    <ol className="list-decimal ml-5">
                      {prescription?.patientDiagnosisDetails
                        ?.filter(
                          (diagnosis) =>
                            diagnosis?.diagnosisType === "Secondary" &&
                            diagnosis?.status === 1
                        )
                        ?.map((secondaryDiagnosis) => (
                          <li>
                            <span>
                              {secondaryDiagnosis?.diagnosisDescription}
                            </span>
                            <span className="font-bold">
                              ({secondaryDiagnosis?.diagnosisCode})
                            </span>
                          </li>
                        ))}
                    </ol>
                  </>
                </div>
              )}

              <div className="mb-2 overflow-scroll scrollWidth">
                {prescription?.drugPrescription?.length !== 0 && (
                  <div>
                    <p className="mb-2">
                      <b className="font-bold">Medicines :</b>
                    </p>
                    <table className="table-auto w-full mb-5 overflow-y-scroll">
                      <thead className="border-b-2 border-t-2 border-gray-400">
                        <tr>
                          <th className="px-3 py-1 text-left">Medicines</th>
                          <th className="px-3 py-1 text-left">Dosage</th>
                          <th className="px-3 py-1 text-left">Duration</th>
                        </tr>
                      </thead>
                      <tbody>
                        {prescription?.drugPrescription &&
                          prescription?.drugPrescription?.map(
                            (medicine, idx) => {
                              if (medicine?.status !== 0) {
                                return (
                                  <tr className="border-b-2 text-gray-500">
                                    <td className="text-gray-700 font-semibold px-3 py-1">
                                      {medicine?.drugName}
                                    </td>
                                    <td className="text-gray-700 font-semibold px-3 py-1 flex flex-col">
                                      {medicine?.dosage}
                                      <br />(
                                      {medicine?.afterBeforeFood === "AF"
                                        ? "After Food"
                                        : "Before Food"}
                                      )
                                    </td>
                                    <td className="text-gray-700 font-semibold px-3 py-1">
                                      {medicine?.duration} days
                                      <br />
                                      {medicine?.instruction?.length > 20
                                        ? `(${medicine?.instruction?.slice(
                                            0,
                                            20
                                          )}...)`
                                        : medicine?.instruction}
                                    </td>
                                  </tr>
                                );
                              }
                            }
                          )}
                      </tbody>
                    </table>
                  </div>
                )}

                {prescription?.labPrescription?.length !== 0 && (
                  <div className="mt-2  mb-5">
                    <p className="mb-2">
                      <b className="font-bold">Lab Test :</b>
                    </p>

                    <div className="w-[60%]">
                      <div className="text-gray-700 font-semibold">
                        {prescription?.labPrescription &&
                          prescription?.labPrescription
                            ?.filter((item) => item.status !== 0)
                            .map((lab, idx) => {
                              if (lab?.status !== 0) {
                                return (
                                  <div
                                    key={idx}
                                    className="text-sm border text-gray-700 px-3 py-1"
                                  >
                                    {lab?.labTestName?.length > 100
                                      ? lab?.labTestName?.slice(0, 100)
                                      : lab?.labTestName}
                                  </div>
                                );
                              }
                            })}
                      </div>
                    </div>
                  </div>
                )}

                {prescription?.specialityDetails?.length !== 0 && (
                  <div className="mt-2  mb-5">
                    <p className="mb-2">
                      <b className="font-bold">Speciality Notes :</b>
                    </p>

                    <div className="md:w-[60%] w-full">
                      <div>
                        {prescription?.specialityDetails &&
                          prescription?.specialityDetails.map(
                            (template, idx) => (
                              <div
                                key={idx}
                                className={`${
                                  template?.componentDetailsList?.length !== 0
                                    ? "block"
                                    : "hidden"
                                }`}
                              >
                                <p>
                                  <b className="font-semibold border p-1.5 rounded-lg bg-brand-lightBlue">
                                    {template.templateName}
                                  </b>
                                </p>
                                <div className="w-full flex items-center gap-2 flex-wrap">
                                  {template?.componentDetailsList.map(
                                    (formFields, index) => (
                                      <div
                                        key={index}
                                        className="text-sm flex items-center gap-1"
                                      >
                                        <p className="font-medium w-max my-1 py-1">
                                          {formFields.componentLabel}
                                        </p>
                                        {" : "}
                                        <p className="text-gray-700 w-max my-1 py-1">
                                          {formFields.componentValue}
                                        </p>
                                        {template?.componentDetailsList
                                          ?.length -
                                          1 !==
                                          index && (
                                          <span className="font-medium">|</span>
                                        )}
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            )
                          )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="my-2">
                <div className="w-6/6  my-2">
                  <div className="mb-5">
                    <p>
                      <b className="mr-3">Recommendation :</b>
                      <span className="text-gray-700 font-semibold">
                        {prescription?.recommendation}
                      </span>
                    </p>
                  </div>

                  <div>
                    <p className=" my-2">
                      <b className="mr-3">Scheduled follow up visit date :</b>
                      <span className="text-gray-700 font-semibold">
                        {prescription?.followupVisitDate
                          ? `${
                              prescription?.followupVisitDate
                                ?.slice(0, 10)
                                .split("/")[1]
                            }/${
                              prescription?.followupVisitDate
                                ?.slice(0, 10)
                                .split("/")[0]
                            }/${
                              prescription?.followupVisitDate
                                ?.slice(0, 10)
                                .split("/")[2]
                            }`
                          : ""}
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex justify-between px-4">
                <div className="flex  items-center">
                  {doctorData?.doctorStampName ? (
                    <img
                      id="imag"
                      src={`${process.env.REACT_APP_IMAGE_URL}${doctorData?.doctorStampName}`}
                      alt="Stamp"
                      className="h-32 w-36 rounded-full"
                    />
                  ) : (
                    <div>&nbsp;</div>
                  )}
                </div>

                <div className="">
                  {doctorData?.doctorSignatureName ? (
                    <img
                      src={`${process.env.REACT_APP_IMAGE_URL}${doctorData?.doctorSignatureName}`}
                      alt="Signature"
                      className="w-28 h-28  rounded-full"
                    />
                  ) : (
                    <div>&nbsp;</div>
                  )}
                  <p className="font-bold text-sm mb-1">
                    Dr.{doctorData?.firstName}
                  </p>
                  <p className="font-semibold text-gray-700 text-sm mb-1">
                    {doctorData?.qualification}
                    <br />
                    {doctorData?.speciality}
                  </p>
                  <p className="font-semibold text-gray-700 text-sm mb-1">
                    Regn No. {doctorData?.registrationNumber}
                  </p>
                </div>
              </div>
            </div>
            <div>
              <PrescriptionFooter
                clinicDetails={clinicDetails}
                doctorData={doctorData}
              />
            </div>
            <div className="grid grid-cols-1 ">
              <div className="px-1 py-1">
                <p className="text-gray-700 text-sm "></p>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default PrescriptionDetails;
